import { useRef } from 'react';

/**
 * Custom hook per utilizzare la forwardRef se definita o una ref locale al componente.
 */
export default function useForwardRefOrRef(forwardedRef) {
  const ref = useRef();
  return forwardedRef || ref;
}
